import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatProgressBarModule, MatProgressBar } from '@angular/material/progress-bar';
import { UwButtonModule } from '../button/button.module';
import { UwButtonComponent } from '../button/button.component';

@Component({
    selector: 'uw-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    imports: [MatProgressBar, MatIconButton, MatIcon, UwButtonComponent, TranslateModule]
})
export class DialogComponent {
  // Public properties
  viewLoading = false;

  @Input() public data: any;

  @Input() public dialogRef!: MatDialogRef<any>

  @Output()
  submit = new EventEmitter();

  cancelBtnText = 'buttons.cancel';

  constructor() {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  singleBtnClick(): void {
    this.submit.emit();
  }

  onYesClick(): void {
    this.submit.emit();
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}

@NgModule({
    exports: [DialogComponent],
    imports: [
        CommonModule,
        MatProgressBarModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        UwButtonModule,
        DialogComponent
    ],
})
export class DialogModule {}
